import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faBuilding, faCaretRight, faImage, faMapMarker, faPhone, faStar, faUsers, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Business } from 'backend/interfaces/business.interface';
import { Group } from 'backend/interfaces/group.interface';
import { DataService } from 'src/app/services/data.service';
import { AdViewerDialogComponent } from 'src/app/shared/ad-viewer-dialog/ad-viewer-dialog.component';
import { ViewBusinessDialogComponent } from 'src/app/shared/view-business-dialog/view-business-dialog.component';

@Component({
  selector: 'app-view-category',
  templateUrl: './view-category.component.html',
  styleUrls: ['./view-category.component.scss']
})
export class ViewCategoryComponent implements OnInit {
  loading = false;
  groupId;
  category: Group;
  faAddressPin = faMapMarker;
  faPhone = faPhone;
  faUsers = faUsers;
  faImage = faImage;
  faBuilding = faBuilding;
  faStar = faStar;
  ads;
  faCaretRight = faCaretRight;
  mappedBusinesses = [];
  today = new Date().toLocaleDateString('en-ZA', { weekday: 'long' });
  currentTime = new Date().toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit', hour12: false });
  geolocationPermision = false;
  faShareNodes = faShareAlt;
  constructor(private router: Router, private ar: ActivatedRoute, public dialog: MatDialog, private dataService: DataService, private _snackBar: MatSnackBar) { }

  async ngOnInit(): Promise<void> {
    this.loading = true
    this.groupId = this.ar.snapshot.params['id'];
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted") {
        this.geolocationPermision = true;
      }
    });

    this.dataService.getGroupById(this.groupId).then(async res => {
      this.category = res;
      await this.dataService.getAdsByCategoryId(this.groupId).then(async res => {
        this.ads = await res
      });
      this.loading = false;
    });
  }

  favouriteBusiness() {
    this.router.navigate(['auth', 'login'], { queryParams: { returnUrl: this.router.url } });
  }

  viewBusiness(business: Business) {
    this.dataService.business.next(business);
    this.router.navigate(['business/', business.Name])
    // const dialogRef = this.dialog.open(ViewBusinessDialogComponent, {
    //   width: '100%',
    //   height: '100%',
    //   data: {business},
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('Business was closed');
    // });
  }

  async viewBusinessFromAd(businessId: string): Promise<void> {
    this.loading = true;
    const business = await this.category.businessess.find(b => {
      return b.id === businessId
    });
    this.dataService.business.next(business);
    this.router.navigate(['business/', business.Name])
    // const dialogRef = this.dialog.open(ViewBusinessDialogComponent, {
    //   width: '100%',
    //   height: '100%',
    //   data: {business},
    // });
    // this.loading = false
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('Business was closed');
    // });
  }

  viewAds(ads: any) {
    const dialogRef = this.dialog.open(AdViewerDialogComponent, {
      data: { ads },
      width: '90vw',
      height: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Business was closed');
    });
  }

  goTo(route: string) {
    this.router.navigate(['auth', 'login'])
  }

  copyLink(business: Business) {
    const url = `${window.location.origin}/business/${encodeURIComponent(business.Name)}`;
    this.copyText(url).then(() => {
      this.openSnackBar('Link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      this.openSnackBar('Failed to copy link');
    });
  }

  shareViaWhatsApp(business: Business) {
    const url = `${window.location.origin}/business/${encodeURIComponent(business.Name)}`;
    const text = `Check out ${business.Name} on ADVIBE: ${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  }

  private copyText(text: string): Promise<void> {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    const input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.focus();
    input.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(input);
    return copied ? Promise.resolve() : Promise.reject(new Error('Clipboard copy was rejected'));
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }

  setNearbyBusinesses(locationsWithDistances: any) {
    console.log(locationsWithDistances)
    this.mappedBusinesses = locationsWithDistances
  }

  compareTime(currentTime, endTime, startTime): string {
    const parts1 = endTime.split(':').map(Number); // [10, 30]
    const parts2 = currentTime.split(':').map(Number); // [11, 45]
    const parts3 = startTime.split(':').map(Number); // [08, 00]


    if (parts2[0] <= parts1[0] && parts2[0] >= parts3[0]) { // Compare hours
      return 'Open'
    } else if (parts2[0] > parts1[0] || parts2[0] <= parts3[0]) {
      return 'Closed'
    } else {
      // Hours are equal, compare minutes
      if (parts2[1] <= parts1[1] && parts2[1] >= parts3[1]) {
        return 'Open'
      } else if (parts2[1] > parts1[1] || parts2[1] <= parts3[1]) {
        return 'Closed'
      } else {
        return 'Closed'
      }
    }
  }
}
